import { Button, Tooltip } from "@mui/joy";
import { DataGridPremium, GridFilterModel, GridRowModel, GridToolbar } from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import NewPayLinkModal from "../etc/newpaylink";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getFetch, postFetch } from "../../../../../fetch/fetch";
import { head, set } from "lodash";
import { englishLocationToKorean } from "../../../../../data/locationFuntion";
import { dateToDateString } from "../../etc/etcfunctions";
import { Backdrop, CircularProgress, InputBase, ToggleButton, ToggleButtonGroup } from "@mui/material";
import PayModal from "../etc/paymodal";
import ImageModal2 from "../../../use/imagemodal2";
import ImageIcon from '@mui/icons-material/Image';
import { createStyles, makeStyles } from '@mui/styles';
import { createTheme, darken, lighten } from '@mui/material/styles';
import totalLocationData from "../../../../../data/locationdata";
import EditPayLinkInfoModal from "../etc/editpaylinkinfo";
import WinterPayCancelModal from "../etc/winterpaycancelmodal";
import WinterPayLinkModal from "../etc/winterpaylinkmodal";
import { Modal, ModalDialog, Radio, RadioGroup } from "@mui/joy";

/**
 * 결제관리 > 신규 결제링크 — newpaylinkmain.tsx 의 소탭이 mode 를 넘긴다.
 *  mode "register": 기존 신규 결제링크(linkType != 'winter')만. 진행 단계 열 숨김.
 *  mode "winter"  : 윈터 셀프 결제 링크(linkType 'winter', 제출 전 가상 행 포함)만. 진행 단계 열·상태 '링크 발송됨' 표시, 발송하기/재전송하기 버튼 없음(윈터 재발송은 등록관리 체크박스 발송).
 *                   10/10 '윈터 결제링크 전송하기'(winterpaylinkmodal, 직원 발송 winterSource 'staff') + '분할결제' 열 — 분할은 서버가 회차 행을 1행으로 합쳐 splitParts 로 내려줌.
 *                   분할 행 매칭은 회차를 먼저 골라 그 회차 bill_id·금액으로 매칭(→ 그 회차 링크만 닫힘).
 */
const NewPayLinkSend: React.FC<any> = (props) => {

    const mode: "register" | "winter" = props.mode === "winter" ? "winter" : "register";


    const [cancelLoading, setCancelLoading] = useState(false);

    const letsUpdate = () => {
        setUpdate(Math.random());
    }

    const destroyForNew = async (billId: string) => {

        try {

            if (!window.confirm("정말로 파기하시겠습니까? 파기한 결제링크는 복구할 수 없습니다.")) {
                return;
            }

            setCancelLoading(true);

            console.log({
                billId: billId
            });

            const result: any = await postFetch("/dashboard/payments/managepayments/destroyfornewsend", {
                billId: billId
            });

            setCancelLoading(false);

            console.log(result);

            if (result.message === "success") {

                letsUpdate();

            } else {
                alert(result.detail);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const [rows, setRows] = useState<any[]>([]);
    const [cancelRow, setCancelRow] = useState<any>(null); // 윈터 탭 '취소하기' 대상 행 (columns 의 renderCell 에서 씀)
    const [columns, setColumns] = useState<any[]>([
        { field: "dueDate", headerName: "만료시간", width: 180 },
        { field: "name", headerName: "이름", width: 80 },
        { field: "gender", headerName: "성별", width: 80 },
        { field: "phoneNumber", headerName: "전화번호", width: 150 },
        { field: "location", headerName: "지점", width: 100 },
        { field: "seat", headerName: "좌석", width: 80 },
        { field: "date", headerName: "등록기간", width: 200 },
        { field: "price", headerName: "금액", width: 150 },
        //분할결제(윈터 직원 발송만): 회차 금액 / 회차 … — ✓ = 그 회차 결제됨
        { field: "split", headerName: "분할결제", width: 230 },
        { field: "status", headerName: "상태", width: 100 },
        {
            //진행 단계(윈터예약만): 결제 페이지에서 어디까지 갔는지 — 가장 멀리 간 단계를 보여주고, 마우스를 올리면 단계별 시각
            field: "stage", headerName: "진행 단계", width: 130, renderCell: (params: any) => {
                const row = params.row;
                if (!row.stageSteps) return <div>-</div>;
                return (
                    <Tooltip
                        variant="outlined"
                        placement="right"
                        title={
                            <div style={{ fontSize: "12px", lineHeight: 1.7, padding: "4px 2px" }}>
                                {row.stageSteps.map((step: any) => (
                                    <div key={step.label} style={{ color: step.at ? "#191f28" : "#B0B8C1" }}>
                                        {step.at ? "✓" : "·"} {step.label}{step.at ? ` — ${step.at}` : ""}
                                    </div>
                                ))}
                            </div>
                        }
                    >
                        <div style={{ cursor: "default", fontWeight: 600, color: row.stageColor }}>{params.value}</div>
                    </Tooltip>
                );
            }
        },
        { field: "paymentMethod", headerName: "결제수단", width: 120 },
        {
            field: 'image', headerName: '인증사진', width: 80, renderCell: (params: any) => {

                const id = params.row.id;
                const userId = params.row.userId;

                if (params.value) {

                    return (
                        <div
                            onClick={(e: any) => {
                                setImageSrc(params.value);
                                setModalOpen10(true);
                            }}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                height: "100%",
                                cursor: "pointer"
                            }}>
                            <ImageIcon color="success" />
                        </div>
                    )

                } else {
                    return (
                        <div style={{
                        }}>
                            -
                        </div>
                    )
                }

            }
        },
        { field: "memo", headerName: "메모", width: 150, editable: true },
        { field: "createdAt", headerName: "생성일", width: 200 },
        { field: "teacherName", headerName: "발송자", value: 100 },
        {
            field: "destroy", headerName: "파기하기", width: 150, renderCell: (params: any) => {

                const row = params.row;

                const bill_id = row.bill_id;

                if (row.status !== "미결제") {
                    return (
                        <></>
                    )
                }

                const submit = async () => {

                    await destroyForNew(bill_id);

                }

                return (
                    <Button
                        variant="solid"
                        color="neutral"
                        onClick={submit}
                        size="sm"
                    >
                        파기하기
                    </Button>

                )

            }
        },
        {
            //취소하기 (윈터 탭만 표시) — 결제 완료 행에만, todoistApiKey 보유자만(서버도 noTodoistApiKey 로 거부). winterpaycancelmodal → /managepayments/cancelwinterpayment
            field: "cancel", headerName: "취소하기", width: 110, renderCell: (params: any) => {
                const row = params.row;
                if (row.virtual || row.status !== "결제 완료" || !(props.user && props.user.todoistApiKey)) {
                    return <></>;
                }
                return (
                    <Button
                        variant="outlined"
                        color="danger"
                        size="sm"
                        onClick={(e) => { e.stopPropagation(); setCancelRow(row); }}
                    >
                        취소하기
                    </Button>
                );
            }
        }
    ]);
    const [modalOpen8, setModalOpen8] = useState<boolean>(false);
    const [modalOpen10, setModalOpen10] = useState<boolean>(false);
    const [registerPayInfo, setRegisterPayInfo] = useState<any[]>([]);
    const [update, setUpdate] = useState(0);
    const [loading, setLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [loading2, setLoading2] = useState(false);
    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: [
            { id: 2, field: 'name', operator: 'contains', value: "" },
            { id: 3, field: "location", operator: "isAnyOf", value: [] },
            { id : 4, field : "status", operator : "contains", value : "" },
            { id : 5, field : "paymentMethod", operator : "contains", value : "" },
        ],
    });
    const [modalOpen9, setModalOpen9] = useState(false);
    const [modalOpen11, setModalOpen11] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState<number | null>(null);
    const [selectedBillId, setSelectedBillId] = useState<string | null>(null);
    const [selectedIsFinish, setSelectedIsFinish] = useState<boolean>(false);
    const [imageSrc, setImageSrc] = useState<string>("");
    const [alignment2, setAlignment2] = useState<string>('total');
    const [alignment3, setAlignment3] = useState<string>('total');
    const [alignment4, setAlignment4] = useState<string>('total');
    const [deletedLoading, setDeletedLoading] = useState(false);
    const [winterSendOpen, setWinterSendOpen] = useState(false); // 윈터 결제링크 전송하기 팝업
    const [winterEnrolledOpen, setWinterEnrolledOpen] = useState(false); // 재학생 윈터 결제링크 발송하기 팝업 (결제선생 바로 전송)
    const [splitPickOpen, setSplitPickOpen] = useState(false); // 분할 행 매칭 — 회차 고르기
    const [splitPickId, setSplitPickId] = useState<string>("");
    const [matchPrice, setMatchPrice] = useState<number | null>(null); // 분할 회차 매칭이면 그 회차 금액

    const defaultTheme = createTheme();
    const useStyles = makeStyles(
        (theme) => {
            const getBackgroundColor = (color: any) =>
                theme.palette.mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

            const getHoverBackgroundColor = (color: any) =>
                theme.palette.mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

            return {
                root: {
                    '& .super-app-theme--처리완료': {
                        backgroundColor: getBackgroundColor(theme.palette.info.main),
                        '&:hover': {
                            backgroundColor: getHoverBackgroundColor(theme.palette.info.main),
                        },
                    },
                    '& .super-app-theme--Filled': {
                        backgroundColor: getBackgroundColor(theme.palette.success.main),
                        '&:hover': {
                            backgroundColor: getHoverBackgroundColor(theme.palette.success.main),
                        },
                    },
                    '& .super-app-theme--확인': {
                        backgroundColor: getBackgroundColor(theme.palette.warning.main),
                        '&:hover': {
                            backgroundColor: getHoverBackgroundColor(theme.palette.warning.main),
                        },
                    },
                    '& .super-app-theme--미확인': {
                        backgroundColor: getBackgroundColor(theme.palette.error.main),
                        '&:hover': {
                            backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
                        },
                    },
                    '& .paid': {
                        backgroundColor: getBackgroundColor(theme.palette.success.main),
                        '&:hover': {
                            backgroundColor: getHoverBackgroundColor(theme.palette.success.main),
                        },
                    },
                    '& .waiting': {
                        backgroundColor: getBackgroundColor(theme.palette.warning.main),
                        '&:hover': {
                            backgroundColor: getHoverBackgroundColor(theme.palette.warning.main),
                        },
                    },
                    '& .important': {
                        backgroundColor: getBackgroundColor(theme.palette.error.main),
                        fontWeight : 700,
                        '&:hover': {
                            backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
                        },
                    }
                },
            };
        },
        { defaultTheme },
    );

    const classes = useStyles();


    const handleClose9 = () => {
        setModalOpen9(false);
    }

    const getRegisterPayInfo = async () => {

        try {

            setLoading(true);

            const result: any = await getFetch("/dashboard/payments/managepayment/getregisterpayinfo");

            setLoading(false);

            console.log(result);

            const { registerPayInfo } = result;

            setRegisterPayInfo([...registerPayInfo]);

        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        getRegisterPayInfo();
    }, []);

    const notify1 = () => toast.success("결제 링크 전송이 성공했습니다.", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });

    const getPayLinkDatas = async () => {

        try {

            const result: any = await getFetch("/dashboard/payments/managepayment/getpaylinklist");

            if (result.message === "success") {
                const { payLinkList } = result;

                const newRows: any = [];

                payLinkList.forEach((link: any) => {

                    //소탭 분리 — 윈터 탭은 linkType 'winter' 만, 신규 탭은 그 외만
                    const isWinter = link.linkType === "winter";
                    if (mode === "winter" ? !isWinter : isWinter) return;

                    const oneRow: any = {};

                    const dueDate = new Date(link.dueDate);
                    oneRow.dueDate = dateToDateString(dueDate, true);

                    oneRow.id = link.id;
                    oneRow.virtual = !!link.virtual; // 아직 제출 전인 윈터 링크(newPayLink 없음) — 액션 버튼·메모 편집 불가
                    oneRow.name = link.name;
                    oneRow.teacherName = link.teacherName;
                    const phoneNumber = link.phoneNumber;
                    oneRow.phoneNumber = phoneNumber.slice(0, 3) + "-" + phoneNumber.slice(3, 7) + "-" + phoneNumber.slice(7, 11);
                    oneRow.bill_id = link.bill_id;
                    oneRow.location = englishLocationToKorean(link.location);
                    oneRow.englishLocation = link.location;
                    oneRow.seat = link.seat;
                    oneRow.price = link.virtual ? (link.price ? link.price.toLocaleString() : "-") : (link.price || 0).toLocaleString();
                    if(link.appliedDiscount && link.appliedDiscount > 0){
                        oneRow.price += ` (${link.appliedDiscount}% 할인)`;
                    }
                    oneRow.priceNumber = link.price;
                    oneRow.status = link.isPaidCalculated ? "결제 완료" : "미결제";
                    oneRow.winterSource = link.winterSource || null;
                    //분할결제 — 서버가 합친 회차 목록
                    oneRow.splitParts = Array.isArray(link.splitParts) ? link.splitParts : null;
                    oneRow.split = oneRow.splitParts
                        ? oneRow.splitParts.map((part: any) => (+part.price).toLocaleString() + (part.isPaid ? "✓" : "")).join(" / ")
                        : "-";
                    oneRow.startDate = link.startDate;
                    oneRow.endDate = link.endDate;
                    oneRow.appliedDiscount = link.appliedDiscount;

                    var paymentMethodText = "";

                    if (link.paymentMethod === "payteacher") {
                        paymentMethodText = "결제선생";
                    }
                    if (link.paymentMethod === "onSite") {
                        paymentMethodText = "현장결제";
                    }
                    if (link.paymentMethod === "withdrawal") {
                        paymentMethodText = "계좌이체";
                    }
                    if (link.paymentMethod === "local") {
                        paymentMethodText = "지역화폐";
                    }

                    oneRow.paymentMethod = paymentMethodText;
                    oneRow.paymentMethodRaw = link.paymentMethod;
                    oneRow.studentName = link.studentName || null;
                    oneRow.studentPhoneNumber = link.studentPhoneNumber || null;
                    oneRow.parentPhoneNumber = link.parentPhoneNumber || null;

                    oneRow.order_id = link.order_id;
                    oneRow.bill_id = link.bill_id;
                    oneRow.isFinish = link.isFinish;
                    oneRow.image = link.imageSrc ? link.imageSrc : null;
                    oneRow.gender = link.gender === "male" ? "남학생" : link.gender === "female" ? "여학생" : "";
                    oneRow.genderEnglish = link.gender;

                    const startDate = new Date(link.startDate);
                    const endDate = new Date(link.endDate);
                    oneRow.date = link.startDate && link.endDate ? dateToDateString(startDate, false) + " ~ " + dateToDateString(endDate, false) : "-";
                    if (link.virtual) {
                        oneRow.paymentMethod = "-";
                        oneRow.status = dueDate < new Date() ? "만료" : "링크 발송됨";
                    }

                    if(oneRow.status === "미결제" && link.imageSrc){
                        oneRow.status = "매칭 대기 중"
                    }


                    if (oneRow.status === "미결제" && dueDate < new Date()) {
                        oneRow.status = "만료";
                    }

                    if (oneRow.status === "미결제" && link.isDestroy) {
                        oneRow.status = "파기됨";
                    }

                    //윈터예약 진행 단계 — 서버가 winterPayLink 의 시각들을 같이 내려준다(열람·번호 인증·결제 클릭·제출은 결제 페이지가 기록)
                    if (link.linkType === "winter") {
                        const fmt = (v: any) => v ? dateToDateString(new Date(v), true) : null;
                        const allSteps = [
                            { label: "발송됨", at: fmt(link.createdAt) },
                            { label: link.openCount ? `열람 (${link.openCount}회)` : "열람", at: fmt(link.openedAt) },
                            { label: "번호 인증", at: fmt(link.certifiedAt) },
                            { label: "결제 클릭", at: fmt(link.payClickedAt) },
                            { label: "제출 (결제 수단 선택)", at: fmt(link.submittedAt) },
                            { label: "인증샷 업로드", at: fmt(link.imageUploadedAt) },
                            { label: link.paidAlimtalkSentAt ? "결제 완료 (완료 알림톡 발송)" : "결제 완료", at: link.isPaidCalculated ? (fmt(link.paidAlimtalkSentAt) || "완료") : null },
                        ];
                        //직원 발송(/registerlink)·재학생 결제선생 발송 링크는 열람·인증·결제 클릭·제출 기록이 없어 발송·인증샷·결제 완료만
                        const steps = link.winterSource === "staff" || link.winterSource === "enrolled"
                            ? allSteps.filter((step) => step.label === "발송됨" || step.label === "인증샷 업로드" || step.label.indexOf("결제 완료") === 0)
                            : allSteps;
                        var top = steps[0];
                        steps.forEach((step) => { if (step.at) top = step; });
                        oneRow.stageSteps = steps;
                        oneRow.stage = top.label.replace(/ \(.*\)$/, "");
                        oneRow.stageColor = top === steps[steps.length - 1] ? "#1B9C5A" : top === steps[0] ? "#8B95A1" : "#1B64DA";
                    }

                    oneRow.memo = link.memo ? link.memo : "";
                    oneRow.createdAt = dateToDateString(new Date(link.createdAt), true);

                    newRows.push(oneRow);
                });

                setRows([...newRows]);
                setSelectedRow((prev: any) => {
                    if (!prev) return null;
                    const updated = newRows.find((r: any) => r.id === prev.id);
                    return updated ? updated : prev;
                });
            }

        } catch (e) {
            console.log(e);
        }

    }

    useEffect(() => {
        getPayLinkDatas();
    }, [update]);

    const handleEditCommit = React.useCallback(
        async (newRow: GridRowModel, old: any) => {
            if (newRow.virtual) return old; // 제출 전 윈터 링크(가상 행)는 newPayLink 가 없어 메모 저장 불가
            var field = "";


            for (const [key, value] of Object.entries(newRow)) {
                if (value !== old[key]) {
                    field = key;

                }
            }

            const cellValue = newRow[field] ? newRow[field] : "";

            if (field === "memo") {

                fetch("https://peetsunbae.com/dashboard/payments/managepayment/updatememofornewpaylink", {
                    method: "POST",
                    headers: { "content-type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify({
                        id: newRow.id,
                        value: cellValue,
                        field
                    })
                }).then((response: any) => {
                    response.json()
                        .then((result: any) => {

                        })
                })
            }

            return newRow;
        }, []
    );

    const handleProcessRowUpdateError = React.useCallback((error: Error) => {

        alert(error.message);
    }, []);


    const makeLink = async (location: string, value: [Date, Date], seat: number, price: number, appliedDiscount: number, phoneNumber: string, name: string, dueHours: number, gender: string) => {

        try {

            if (!location || !value[0] || !value[1]) {
                return;
            }


            setLoading(true);


            // startDate.setHours(0, 0, 0, 0);
            // endDate.setHours(23, 59, 59, 999);

            // const startDateTime = startDate.getTime();
            // const endDateTime = endDate.getTime();

            const startDate = value[0];
            const endDate = value[1];

            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(23, 59, 59, 999);

            const startDateTime = startDate.getTime();
            const endDateTime = endDate.getTime();

            const data = {
                location: location,
                seat,
                startDateTime: startDateTime,
                endDateTime: endDateTime,
                price,
                appliedDiscount,
                phoneNumber: phoneNumber.replace(/\D/g, ''),
                name,
                dueHours,
                gender
            }

            console.log(data);

            const result: any = await postFetch("/dashboard/payments/managepayments/createpaylink", data);

            setLoading(false);

            if (result.message === "success") {
                props.notify1();
                props.handleClose();
                props.setUpdate(Math.random());
            }

            return;

        } catch (e) {
            console.log(e);
        }
    }

    const parseDateTime = (s: string) => new Date(s.replace(" ", "T"));

    const calcDueHours = (dueDateStr: string, createdAtStr: string) => {
        const due = parseDateTime(dueDateStr).getTime();
        const created = parseDateTime(createdAtStr).getTime();
        const diffHours = (due - created) / (1000 * 60 * 60);
        return Math.max(1, Math.ceil(diffHours)); // 최소 1시간
    };

    const handleChange2 = (e: any, newAlignment: string) => {

        if (!newAlignment) {
            return;
        }

        setAlignment2(newAlignment);

        const newFilterModel: any = filterModel;

        const locationList: any = [];

        totalLocationData.forEach((location) => {

            if (newAlignment === "total") {


            } else if (location.english === newAlignment) {

                locationList.push(location.korean);
            }

        });

        newFilterModel.items.forEach((each: any) => {
            if (each.id === 3) {
                each.value = locationList;
            }
        })



        setFilterModel({ ...newFilterModel });

    }

    const handleChange3 = (e: any, newAlignment: string) => {
        
        if (!newAlignment) {
            return;
        }

        setAlignment3(newAlignment);

        const newFilterModel: any = filterModel;
        
        newFilterModel.items.forEach((each: any) => {
            if (each.id === 4) {
                if(newAlignment === "total"){
                    each.value = "";
                }
                else{
                    each.value = newAlignment === "completed" ? "결제 완료" : newAlignment === "unpaid" ? "미결제" : newAlignment === "expired" ? "만료" : newAlignment === "sent" ? "링크 발송됨" : "";
                }
            }
        }
        )
        setFilterModel({ ...newFilterModel });
        
    }

    const handleChange4 = (e: any, newAlignment: string) => {

        if (!newAlignment) {
            return;
        }

        setAlignment4(newAlignment);
        
        const newFilterModel: any = filterModel;

        newFilterModel.items.forEach((each: any) => {
            if (each.id === 5) {
                if(newAlignment === "total"){
                    each.value = "";
                }

                else{
                    const paymentMethodText = newAlignment === "payteacher" ? "결제선생" : newAlignment === "withdrawal" ? "계좌이체" : newAlignment === "onSite" ? "현장결제" : newAlignment === "local" ? "지역화폐" : "";
                    each.value = paymentMethodText;
                }
            }
        }
        )
        setFilterModel({ ...newFilterModel });
        
    }

    

    return (
        <div>
            <div style={{
                paddingTop: "60px",
                width: "2000px",
                height: "700px"
            }}>
                <div>
                    <div style={{
                        marginBottom : "18px"
                    }}>
                        <InputBase
                            placeholder="이름으로 검색"
                            value={filterModel.items.find(item => item.field === 'name')?.value || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setFilterModel((prevModel) => {
                                    const newItems = prevModel.items.filter(item => item.field !== 'name');
                                    if (value) {
                                        newItems.push({ id: Math.random(), field: 'name', operator: 'contains', value });
                                    }
                                    return { ...prevModel, items: newItems };
                                });
                            }}
                            style={{
                                borderBottom: "1px solid black"
                            }}
                        />
                    </div>
                </div>
                <div style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                }}>
                    <div style={{ display: "flex", flexWrap: "wrap", rowGap: "8px", alignItems: "center" }}>
                        <ToggleButtonGroup
                            color="primary"
                            value={alignment2}
                            exclusive
                            onChange={handleChange2}
                            sx={{ marginRight: "20px" }}
                        >
                            {
                                props.user && totalLocationData.filter((each) => each.academy.includes(props.user.academy)).map((each, index) => {
                                    return (
                                        <ToggleButton value={each.english} key={index}>{each.korean}</ToggleButton>
                                    )
                                })
                            }
                        </ToggleButtonGroup>

                        <ToggleButtonGroup
                            color="primary"
                            value={alignment3}
                            exclusive
                            onChange={handleChange3}
                            sx={{ marginRight: "20px" }}
                        >
                            <ToggleButton value={"total"}>전체</ToggleButton>
                            {mode === "winter" && <ToggleButton value={"sent"}>링크 발송됨</ToggleButton>}
                            <ToggleButton value={"completed"}>결제 완료</ToggleButton>
                            <ToggleButton value={"unpaid"}>미결제</ToggleButton>
                            <ToggleButton value={"expired"}>만료</ToggleButton>
                        </ToggleButtonGroup>

                        <ToggleButtonGroup
                            color="primary"
                            value={alignment4}
                            exclusive
                            onChange={handleChange4}
                        >
                            <ToggleButton value={"total"}>전체</ToggleButton>
                            <ToggleButton value={"payteacher"}>결제선생</ToggleButton>
                            <ToggleButton value={"withdrawal"}>계좌이체</ToggleButton>
                            <ToggleButton value={"onSite"}>현장결제</ToggleButton>
                            <ToggleButton value={"local"}>지역화폐</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                    <div style={{ whiteSpace: "nowrap" }}>
                        <Button
                            variant="solid"
                            onClick={async () => {

                                if (!selectedRow) {
                                    return;
                                }

                                if(!window.confirm("선택한 결제링크를 삭제하시겠습니까?")){
                                    return;
                                }

                                setDeletedLoading(true);

                                const result : any = await postFetch("/dashboard/payments/managepayment/deletepaylink", {
                                    id: selectedRow.id
                                });

                                setDeletedLoading(false);

                                if(result.message === "success"){
                                    setSelectedRow(null);
                                    setUpdate(Math.random());
                                }
                            }}
                            disabled={!selectedRow || !!selectedRow.virtual}
                            color="neutral"
                            style={{
                                marginRight: "10px"
                            }}
                            loading={deletedLoading}
                        >
                            삭제하기
                        </Button>
                        <Button
                            variant="solid"
                            onClick={() => {
                                if (!selectedRow) return;
                                setModalOpen11(true);
                            }}
                            disabled={!selectedRow || !!selectedRow.virtual || selectedRow.status === "결제 완료" || selectedRow.status === "파기됨"}
                            color="neutral"
                            style={{
                                marginRight: "10px"
                            }}
                        >
                            정보 수동 입력
                        </Button>
                        <Button
                            variant="solid"
                            onClick={async () => {
                                if (!selectedRow) {
                                    return;
                                }
                                //분할 행: 매칭할 회차부터 고르기
                                if (selectedRow.splitParts && selectedRow.splitParts.length > 0) {
                                    const firstUnpaid = selectedRow.splitParts.find((part: any) => !part.isPaid);
                                    setSplitPickId(firstUnpaid ? String(firstUnpaid.id) : "");
                                    setSplitPickOpen(true);
                                    return;
                                }
                                setMatchPrice(null);
                                setSelectedBillId(selectedRow.bill_id);
                                setModalOpen9(true);
                            }}
                            disabled={!selectedRow || !!selectedRow.virtual || !selectedRow.paymentMethod || selectedRow.status === "결제 완료"}
                            color="neutral"
                            style={{
                                marginRight: "10px"
                            }}
                        >
                            매칭하기
                        </Button>
                        {mode === "winter" && (
                            <Button
                                variant="solid"
                                onClick={() => {
                                    setWinterSendOpen(true);
                                }}
                                sx={{
                                    marginRight: "10px",
                                    backgroundColor: "#1F2A44",
                                    "&:hover": { backgroundColor: "#141C2F" },
                                }}
                            >
                                윈터 결제링크 전송하기
                            </Button>
                        )}
                        {mode === "winter" && (
                            <Button
                                variant="solid"
                                onClick={() => {
                                    setWinterEnrolledOpen(true);
                                }}
                                sx={{
                                    marginRight: "10px",
                                    backgroundColor: "#1F2A44",
                                    "&:hover": { backgroundColor: "#141C2F" },
                                }}
                            >
                                재학생 윈터 결제링크 발송하기
                            </Button>
                        )}
                        {mode === "register" && (<>
                        <Button
                            variant="solid"
                            onClick={async () => {
                                if (!selectedRow) {
                                    return;
                                }

                                if (!window.confirm("선택한 결제링크로 재전송하시겠습니까?")) {
                                    return;
                                }

                                try {
                                    setLoading2(true);

                                    const dueHours = calcDueHours(
                                        selectedRow.dueDate,
                                        selectedRow.createdAt
                                    );

                                    const appliedDiscount = selectedRow.appliedDiscount ? selectedRow.appliedDiscount : 0;

                                    const startDate = new Date(selectedRow.startDate);
                                    const endDate = new Date(selectedRow.endDate);

                                    const priceNumber = Number(
                                        String(selectedRow.price).replace(/,/g, "")
                                    );

                                    await makeLink(
                                        selectedRow.englishLocation,   // "gangnam"
                                        [startDate, endDate],          // ✅ row에서 바로 사용
                                        selectedRow.seat ?? null,          // seat 없을 수도 있으니 안전 처리
                                        priceNumber,
                                        appliedDiscount,                             // appliedDiscount
                                        selectedRow.phoneNumber.replace(/-/g, ""),
                                        selectedRow.name,
                                        dueHours,
                                        selectedRow.genderEnglish
                                    );

                                } finally {
                                    setLoading2(false);
                                    setUpdate(Math.random());
                                }
                            }}
                            color="neutral"
                            style={{
                                marginRight: "10px"
                            }}
                            disabled={!selectedRow || !!selectedRow.virtual}
                            loading={loading2}
                        >
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                            }}>
                                재전송하기
                            </div>
                        </Button>
                        <Button
                            variant="solid"
                            onClick={() => {
                                setModalOpen8(true);
                            }}
                            color="neutral"
                            style={{
                                marginRight: "10px"
                            }}
                        >
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                            }}>
                                신규 결제링크 발송하기
                            </div>
                        </Button>
                        </>)}
                    </div>
                </div>
                <div className={classes.root} style={{ height: 900, width: 2000, backgroundColor: "white" }}>
                    <DataGridPremium
                        components={{ Toolbar: GridToolbar}}
                        rows={rows}
                        columns={columns}
                        density="compact"
                        processRowUpdate={handleEditCommit}
                        onProcessRowUpdateError={handleProcessRowUpdateError}
                        loading={loading}
                        onRowClick={(params: any) => {
                            console.log(params.row);
                            setSelectedRow(params.row);
                            console.log(params.row);
                            setSelectedOrderId(params.row.order_id);
                            setSelectedBillId(params.row.bill_id);
                            setSelectedIsFinish(params.row.isFinish);
                        }}
                        filterModel={filterModel}
                        onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
                        initialState={{ columns: { columnVisibilityModel: mode === "register" ? { stage: false, cancel: false, split: false } : {} } }}
                        getCellClassName={(params: any) => {

                            if (params.field === "status" && params.value === "결제 완료") {
                                return "paid"
                            }

                            if (params.field === "status" && params.value === "미결제") {
                                return "waiting"
                            }

                            if(params.field === "status" && params.value === "매칭 대기 중"){
                                return "important"
                            }

                            return ""
                        }}
                    />
                </div>
            </div>

            <NewPayLinkModal
                open={modalOpen8}
                handleClose={() => setModalOpen8(false)}
                registerPayInfo={registerPayInfo}
                notify1={notify1}
                setUpdate={setUpdate}
                user={props.user}
            />


            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={cancelLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>


            <PayModal
                open={modalOpen9}
                handleClose={handleClose9}
                selectedStudent={{
                    name: selectedRow ? selectedRow.name : "",
                }}
                setUpdate={setUpdate}
                selectedUnpaidOrderItem={{
                    //분할 회차 매칭이면 그 회차 금액
                    price: matchPrice ? matchPrice : selectedRow ? Number(String(selectedRow.priceNumber).replace(/,/g, "")) : 0,
                    id: selectedOrderId ? selectedOrderId : 0,
                }}
                isNewPayLink={true}
                selectedBillId={selectedBillId}
            />


            <WinterPayLinkModal
                open={winterSendOpen}
                handleClose={() => setWinterSendOpen(false)}
                setUpdate={setUpdate}
                user={props.user}
            />

            <WinterPayLinkModal
                open={winterEnrolledOpen}
                handleClose={() => setWinterEnrolledOpen(false)}
                setUpdate={setUpdate}
                user={props.user}
                variant="enrolled"
            />

            {/* 분할 행 매칭 — 회차 고르기 (그 회차 bill_id 로 매칭하면 그 회차 링크만 닫힘) */}
            <Modal open={splitPickOpen} onClose={() => setSplitPickOpen(false)}>
                <ModalDialog>
                    <div style={{ width: "320px" }}>
                        <div style={{ fontFamily: "Apple_SB", fontSize: "20px", marginBottom: "16px" }}>
                            매칭할 회차 선택
                        </div>
                        <RadioGroup
                            value={splitPickId}
                            onChange={(e: any) => setSplitPickId(e.target.value)}
                            sx={{ gap: "8px" }}
                        >
                            {selectedRow && selectedRow.splitParts && selectedRow.splitParts.map((part: any) => (
                                <Radio
                                    key={part.id}
                                    value={String(part.id)}
                                    disabled={!!part.isPaid}
                                    label={`${part.splitIndex}회차 · ${(+part.price).toLocaleString()}원${part.isPaid ? " (결제됨)" : part.imageSrc ? " (인증샷 있음)" : ""}`}
                                />
                            ))}
                        </RadioGroup>
                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                            <Button variant="plain" color="neutral" onClick={() => setSplitPickOpen(false)} sx={{ marginRight: "8px" }}>
                                닫기
                            </Button>
                            <Button
                                variant="solid"
                                disabled={!splitPickId}
                                onClick={() => {
                                    const part = selectedRow && selectedRow.splitParts ? selectedRow.splitParts.find((x: any) => String(x.id) === splitPickId) : null;
                                    if (!part) return;
                                    setSelectedBillId(part.bill_id);
                                    setMatchPrice(+part.price);
                                    setSplitPickOpen(false);
                                    setModalOpen9(true);
                                }}
                            >
                                이 회차 매칭하기
                            </Button>
                        </div>
                    </div>
                </ModalDialog>
            </Modal>

            <EditPayLinkInfoModal
                open={modalOpen11}
                handleClose={() => setModalOpen11(false)}
                selectedRow={selectedRow}
                setUpdate={setUpdate}
            />

            <WinterPayCancelModal
                open={!!cancelRow}
                row={cancelRow}
                onClose={() => setCancelRow(null)}
                onDone={() => { setSelectedRow(null); setUpdate(Math.random()); }}
            />

            <ImageModal2
                open={modalOpen10}
                handleClose={() => { setModalOpen10(false) }}
                src={[imageSrc]}
                isMultiple={false}
            />




        </div>
    )
}

export default NewPayLinkSend;